export default "__VITE_ASSET__DwcMr0RS__"